import { CardHeader } from 'components'
import Checkbox from 'features/forms/components/Checkbox'
import SelectField from 'features/forms/components/SelectField'
import TextField from 'features/forms/components/TextField'
import { NameFormat } from 'generated/graphql'
import React from 'react'
import styled from 'styled-components'
import { colors, _ } from 'utils'

const S = {
    Header: styled(CardHeader)`
        display: flex;
        align-items: center;
        margin: 20px 10px;
    `,
    Description: styled.p`
        font-size: 14px;
        color: ${colors.grayTitle};
        margin: 10px 10px 36px 10px;
    `
}

const EmailContent = () => (
    <>
        <TextField
            name="inviteMailSenderName"
            label={_('email_content.form.sender_name')}
            helperText={_('email_content.form.sender_name_helper_text')}
            showInfoIcon
            lg={1/2}
        />
        <TextField
            name="inviteMailReplyTo"
            label={_('email_content.form.reply_email')}
            helperText={_('email_content.form.reply_email_helper_text')}
            showInfoIcon
            lg={1/2}
        />
        <TextField
            name="inviteMailSubject"
            isRequired
            label={_('email_content.form.subject')}
            lg={1/2}
        />
        <S.Header>
            {_('email_content.form.content_header')}
        </S.Header>
        <TextField
            name="inviteMailSalutation"
            label={_('email_content.form.salutation')}
            lg={1/2}
        />
        <SelectField
            name="inviteMailNameFormat"
            options={[
                { label: _('email_content.form.full_name_format'), value: NameFormat.Full },
                { label: _('email_content.form.first_name_format'), value: NameFormat.First },
                { label: _('email_content.form.last_name_format'), value: NameFormat.Last },
            ]}
            label={_('email_content.form.name_format')}
            isClearable={false}
            lg={1/2}
        />
        <TextField
            name="inviteMailIntro"
            isTextArea
            label={_('email_content.form.email_intro')}
            placeholder={_('email_content.form.email_intro_placeholder')}
            helperText={_('email_content.form.email_intro_helper_text')}
            showInfoIcon
        />
        <S.Description>
            {_('email_content.access_code_and_link_description')}
        </S.Description>
        <TextField
            name="inviteMailOutro"
            isTextArea
            label={_('email_content.form.email_body')}
            placeholder={_('email_content.form.email_body_placeholder')}
            helperText={_('email_content.form.email_body_helper_text')}
            showInfoIcon
        />
        <Checkbox
            name="sendTestEmail"
            label={_('email_content.form.send_test_email')}
        />
    </>
)

export default EmailContent
